(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('StandardReports', StandardReports);

  // @ngInject
  function StandardReports($q, $stateParams, util, Api, ApiFallback, Toast, UtilCacheProvider, ConsumerChartDisplay){

    var baseUrl = '/store/consumer/';
    UtilCacheProvider('consumerDataCache', {
      maxAge: 86400000  // Keeping cache for 1 day
    });

    UtilCacheProvider('filterApiCache');

    UtilCacheProvider('userStoreCache');


    var exportErrorFallBack = ApiFallback.createFallback(serverErrorCodesHandled, handleExportError);

    function handleExportError(reason) {
      Toast.error('standard.report.export.error');
      return $q.reject(reason);
    }

    function serverErrorCodesHandled(statusCode) {
      return _.startsWith(statusCode, '5'); // this will handle 5XX error codes
    }

    return {
      downloadReport : downloadReport,
      getConsumerFilters: getConsumerFilters,
      findUserStores: findUserStores,
      defaultSelectedStores: defaultSelectedStores,
      filteredPercent: filteredPercent,
      getConsumerData: getConsumerData,
      getColorSwatches: getColorSwatches,
      percentTotal: percentTotal,
      transformIntoChartData: transformIntoChartData,
      doArraysContainSameElements: doArraysContainSameElements,
      calloutOptions: calloutOptions,
      sectionOptions: sectionOptions,
      findInSummary: findInSummary
    };

    function sectionOptions(api, valuePrefix, valueSuffix) {
      return {
        api: api,
        valuePrefix: valuePrefix,
        valueSuffix: valueSuffix
      }
    }

    function calloutOptions(summaryKey, values, hideTitle) {
      return {
        summaryKey: summaryKey,
        values: values,
        hideTitle: hideTitle
      };
    }

    function findInSummary(summary, summaryKey, userCohort) {
      var summaryVal = _.find(summary, {metric: summaryKey});
      if(summaryVal) {
        var userCohortValue = _.find(summaryVal.metricValue, {userCohort: userCohort});
        return userCohortValue && userCohortValue.value;
      }

    }

    function getColorSwatches(tfKeys) {
      return [
          {keys: tfKeys || [ConsumerChartDisplay.Colors.tfLine.stroke], value: 'True Fit'},
          {keys: [ConsumerChartDisplay.Colors.nonTFLine.stroke], value: 'Non-True Fit'}
      ];
    }

    function getConsumerFilters(storeKey) {
      return Api.get(baseUrl + 'filters',{
        cache: UtilCacheProvider.get('filterApiCache'),
        params: {storeKey: storeKey}
      }).then(_.property('data'));
    }

    function findUserStores() {
      return Api.get('/user-stores',{ cache : UtilCacheProvider.get('userStoreCache') })
          .then(function (response) {
            var stores = response.data;
            var mappedStores = _.map(stores, function (store) {
              return {
                'storeKey': store.tla,
                'storeName': store.name
              }
            });
            return _.sortBy(mappedStores, ['storeName'])
          });
    }

    function defaultSelectedStores(userStores, selectedStoreKeys) {
      if(!selectedStoreKeys) {
        var storeKeys = _.map(userStores, 'storeKey');
        if(storeKeys.length > 10){
          return _.take(storeKeys,1);
        } else {
          return storeKeys;
        }
      } else {
        return selectedStoreKeys;
      }
    }

    function getFileContent(dashboard, filter, fileType) {
      return $q.when(content(dashboard, filter, fileType))
          .then(function (content) {
            return content;
          });
    }

    /**
     *
     * @param pathPrefix URL prefix for dashboard to be used in download URL
     * @param params params with currently applied filters
     * @returns {string}
     */
    function generateURL(pathPrefix) {
      return baseUrl + pathPrefix;
    }

    function content(pathPrefix, params, fileType) {

      return Api.get(generateURL(pathPrefix), {
        cache : false,
        params: params,
        responseType : 'arraybuffer',
        headers: {
          'Accept': fileType
        },
        specificallyHandled: true,
      },exportErrorFallBack).then(function (response) {
        var disposition = util.parseMultipartHeader(response.headers('content-disposition'));
        return $q.all({
          fileName: disposition.filename,
          dataBlob: new Blob([response.data], { type : disposition['content-type'] })
        });
      });
    }

    function downloadReport(pathPrefix, params, fileType) {
      return getFileContent(pathPrefix, params, fileType)
          .then(function (content) {
            download(content.dataBlob, content.fileName, fileType);
          });
    }

    function filteredPercent(total, usedForReporting) {
      var filtered = _.round(((total - usedForReporting) / total) * 100, 2);
      return (filtered > 1) ? filtered : "<1";
    }

    function getConsumerData(path, detailLevel, params) {
        return Api.get(baseUrl + path + "/" + detailLevel, {
          cache: UtilCacheProvider.get('consumerDataCache'),
          params: params
        }).then(_.property('data'));
    }

    function percentTotal(num, den) {
     return _.round((num/ den) * 100, 2)
    }

    /**
     * This method returns a function which takes rawData as the input and transform the rawData into format expected by Chart.
     * Here metric param will be used to extract the values (datapoints) to be used displayed in charts.
     * @param metric
     * @returns {function(*): *}
     */
    function transformIntoChartData(metric) {
      return function(rawData){
        _.forEach(rawData.dateMetrics, function (data) {
          _.forEach(data.metricValues, function (metricValue) {
            metricValue.value = metricValue.value[metric];
          })
        });
        return rawData;
      };
    }

    function doArraysContainSameElements(currentArray, newArray) {
      return _.isEmpty(_.xor(currentArray || [], newArray || []))
    }

  }

})();
